import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Form, Input, Button, Typography,
} from 'antd';
import { authService } from 'farmx-api';
import { useTranslation } from 'react-i18next';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import FarmXLogo from '../../assets/images/farmx_logo_color_40.png';
import './login.css';

export default function LoginPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const { from } = location.state || { from: { pathname: '/' } };
  const [loginFailed, setLoginFailed] = useState(false);

  async function onFinish(values) {
    const { username, password } = values;
    const success = await authService.login(username, password);
    setLoginFailed(!success);
    if (success) {
      history.replace(from);
    }
  }

  return (
    <div className="container">
      <div className="login-container">
        <div className="logo">
          <img className="header-logo" alt="FarmX" src={FarmXLogo} />
        </div>
        <Form
          className="login-form"
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{
              required: true,
              message: t('Please input your username!'),
              min: 1,
            }]}
          >
            <Input
              data-test-id="login-username"
              placeholder={t('Username')}
              prefix={<UserOutlined className="site-form-item-icon" />}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t('Please input your password!') }]}
          >
            <Input.Password
              data-test-id="login-password"
              placeholder={t('Password')}
              prefix={<LockOutlined className="site-form-item-icon" />}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button" data-test-id="login-submit">
              {t('Login')}
            </Button>
          </Form.Item>
          <Typography.Text type="danger" className="login-message">
            { loginFailed ? t('Login failed') : null }
          </Typography.Text>
        </Form>
      </div>
    </div>
  );
}
